import { gql } from '@apollo/client';

const query = gql`
  query GetReviewAssets(
    $listingId: String
    $first: Int
    $reviewState: ReviewStateRegex
  ) {
    reviewAssets(
      listingId: $listingId
      first: $first
      reviewState: $reviewState
    ) {
      edges {
        node {
          id
          reviewId
          url
          review {
            rating
            displayName
            message
          }
        }
      }
    }
  }
`;

module.exports = query;
